import { CSSProperties, useEffect } from 'react'

import { useScrollLockManager } from '../ScrollLock/useScrollLockManager.js'

export interface BackdropProps {
  onClick?: () => void
  style?: CSSProperties
}

export const Backdrop = ({ onClick, style }: BackdropProps) => {
  const scrollLockManager = useScrollLockManager()

  useEffect(() => {
    scrollLockManager.registerScrollLock()

    return () => {
      scrollLockManager.unregisterScrollLock()
    }
  }, [scrollLockManager])

  return (
    <div
      className="fixed inset-0 bg-background-backdrop"
      style={style}
      onClick={onClick}
      onTouchStart={onClick}
    />
  )
}
